interface Props {
  url: string;
  title?: string;
}

/** A YouTube player that keeps a 16:9 shape at any width. */
const VideoPlayer = ({ url, title }: Props) => {
  return (
    <div className="af-video-frame">
      <iframe
        src={url}
        title={title}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
        loading="lazy"
      />
    </div>
  );
}

export default VideoPlayer;
